import React from 'react'

export type RemoteControlRowProps = {
    button: React.ReactNode
    title: React.ReactNode
    status?: React.ReactNode
    remoteChargingControl?: React.ReactNode
}

export function RemoteControlRow({
    button,
    title,
    status,
    remoteChargingControl,
}: RemoteControlRowProps): React.ReactElement {
    return (
        <div className="flex align-items-center gap-3 py-3 border-bottom-1 border-200 flex-wrap lg:flex-nowrap">
            <span className="lg:flex-shrink-0">{title}</span>

            <div className="flex-1">{status}</div>
            <div className="flex align-items-center gap-2 lg:flex-shrink-0">
                {remoteChargingControl}
                {button}
            </div>
        </div>
    )
}
